module.exports = __webpack_public_path__ + "how_to_steal_a_million.d18378dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/src/img/cinema/how_to_steal_a_million.jpg
// module id = oiNK
// module chunks = 0